import React from 'react';
import { BatteryLowIcon, FolderOpenIcon, HelpCircleIcon, TimerIcon } from 'lucide-react';
import { problems } from '../data/content';
const icons = {
  clock: TimerIcon,
  help: HelpCircleIcon,
  folders: FolderOpenIcon,
  battery: BatteryLowIcon
};
export function SoundFamiliar() {
  return <section className="bg-ivory py-10 sm:py-14" aria-labelledby="familiar-title" data-id="element-134" data-mp="1srtegr85fni1">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-135" data-mp="2qesg7gdp7lms">
        <div className="mx-auto max-w-2xl text-center" data-id="element-136" data-mp="2qeiqltwkfghm">
          <h2 id="familiar-title" className="font-display text-[24px] font-semibold uppercase tracking-tightish text-navy-deep sm:text-3xl" data-id="element-137" data-mp="2lffk050xt27j">
            Does this sound familiar?
          </h2>
          <p className="mt-3 text-[14.5px] leading-snug text-navy-soft sm:text-base" data-id="element-138" data-mp="2bpcsyaddlybu">
            You know how to help your clients. But preparing every therapy session can start to feel
            like another job before the actual therapy even begins.
          </p>
        </div>

        <div className="mt-7 grid grid-cols-2 gap-x-5 gap-y-6 sm:mt-9 sm:gap-x-8 lg:grid-cols-4" data-id="element-139" data-mp="idihf5n521fy">
          {problems.map(problem => {
          const Icon = icons[problem.icon];
          return <div key={problem.title} data-id="element-140" data-mp="8mw27cjc3cxs">
                <Icon className="h-5 w-5 text-teal sm:h-6 sm:w-6" aria-hidden="true" data-id="element-141" data-mp="8m4l16qhhhr1" />
                <h3 className="mt-2 text-[13px] font-semibold uppercase leading-tight tracking-[0.03em] text-navy-deep sm:text-sm" data-id="element-142" data-mp="dl7c1n9mpng0">
                  {problem.title}
                </h3>
                <p className="mt-1.5 text-[12.5px] leading-snug text-navy-soft sm:text-[13.5px]" data-id="element-143" data-mp="3qfh6r7fleox">
                  {problem.detail}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}